import { Tweet } from './twitter';

export * from './twitter';

export default Tweet;
